<div id="container">
    <div id="top_content">
        <div id="toolbar"><app-dashboard-toolbar [username]="username"></app-dashboard-toolbar></div>
    </div>
    <app-project-header></app-project-header>
    <div class="scroll">
       <app-shared-projects-container></app-shared-projects-container>
    </div>
    
</div>